import * as numeral from 'numeral';
import * as _ from 'underscore';

import { AfterViewInit, ChangeDetectorRef, Component, Input, OnChanges, OnInit } from '@angular/core';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { DownloadConfig } from '../../../analytics-core/interfaces/widget.interface';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { ModalService } from '../../../shared/directives/modal/modal.service';
import { CreativesR5Component } from '../creatives-r5/creatives-r5.component';

@Component({
	selector: 'app-display-creative-r5',
	styleUrls: ['./display-creative-r5.component.css'],
	templateUrl: './display-creative-r5.component.html'
})
export class DisplayCreativeR5Component extends CreativesR5Component implements OnInit, OnChanges, AfterViewInit {
	public currentStats: any;
	@Input() downloadconfig: string;
	public downloadConfiguration: DownloadConfig;
	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected cdr: ChangeDetectorRef,
		protected modalService: ModalService
	) {
		super(analyticsService, colorUtilityService, analyticsDataModel, cdr, modalService);
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe(() => {
			this.requestData();
		});
	}

	ngOnInit(): void {
		this.downloadConfiguration = JSON.parse(decodeURI(this.downloadconfig));
		super.ngOnInit();
	}
	ngOnChanges(): void {}

	ngAfterViewInit(): void {
		this.cdr.detectChanges();
	}

	moveToSelectedCarousel(index: number): void {
		this.carousel.moveTo(index);
		this.selectedIndex = index;
		this.currentCreativeData = this.sortedCreatives[this.selectedIndex];
		const pickedData = _.pick(this.sortedCreatives[this.selectedIndex], this.displayStats);
		const keys = [];
		this.currentStats = _.map(this.legend, (legend, legendIndex) => {
			if (pickedData[legend['value']]) {
				const hasPercent = legend['value'].slice(0, -1) + 'Rate' in pickedData;
				const percent_value = hasPercent
					? numeral(pickedData[legend['value'].slice(0, -1) + 'Rate']).format('0,0.00') + '%'
					: '';
				return {
					hasPercent,
					name: legend['displayName'],
					percent_value,
					value: Number(pickedData[legend['value']])
				};
			} else {
				return {
					name: legend['displayName'],
					value: ''
				};
			}
		});
		// tslint:disable-next-line: forin
		for (const key in pickedData) {
			if (key.toLowerCase().includes('rate')) {
				this.currentCreativeData[key] = numeral(this.currentCreativeData[key]).format('0,0.00') + '%';
			}
			keys.push({ name: key, value: this.currentCreativeData[key] });
		}
		this.currentCreativeStats = keys;
	}

	downloadDataInCSV(event: any): void {
		event.preventDefault();
		this.analyticsService.downloadCSV(this.downloadConfiguration.csvQueryKey, this.downloadConfiguration.fileName);
	}

	protected generateGraphDataBySelection(selectionItem: any): any {
		const sortedCreatives = this.sortCreativesBySelection(selectionItem);
		const series = [];
		let length = this.sortedCreatives.length;
		for (let i = 0; i < sortedCreatives.length; i++) {
			const seriesObj: any = {};
			seriesObj['name'] = sortedCreatives[i].creativeName;
			seriesObj['id'] = sortedCreatives[i].versionId;
			seriesObj['data'] = sortedCreatives[i].graphData[selectionItem];
			seriesObj['color'] = this.getColorFromColorConfig(i, 1);
			seriesObj['zIndex'] = length;
			series.push(seriesObj);
			length--;
		}
		const categories = sortedCreatives.length > 0 ? sortedCreatives[0].graphData.dates : [];
		const graphData = { series, categories };
		this.sortedCreatives = _.compact(sortedCreatives);
		this.currentCreativeData = this.sortedCreatives[this.selectedIndex];
		const pickedData = _.pick(this.sortedCreatives[this.selectedIndex], this.displayStats);
		const keys = [];

		this.currentStats = _.map(this.legend, (legend, index) => {
			if (pickedData[legend['value']]) {
				const hasPercent = legend['value'].slice(0, -1) + 'Rate' in pickedData;
				const percent_value = hasPercent
					? numeral(pickedData[legend['value'].slice(0, -1) + 'Rate']).format('0,0.00') + '%'
					: '';
				return {
					hasPercent,
					name: legend['displayName'],
					percent_value,
					value: Number(pickedData[legend['value']])
				};
			} else {
				return {
					name: legend['displayName'],
					value: ''
				};
			}
		});
		// tslint:disable-next-line: forin
		for (const key in pickedData) {
			if (key.toLowerCase().includes('rate')) {
				this.currentCreativeData[key] = numeral(this.currentCreativeData[key]).format('0,0.00') + '%';
				this.currentCreativeData['hasPercent'] = true;
			}
			keys.push({ name: key, value: this.currentCreativeData[key] });
		}
		this.currentCreativeStats = keys;
		return graphData;
	}
}
